/* Encuentra tu talla · cargador (todas las páginas). Abre el diálogo, trae su sección y solo entonces carga el motor y
   la interfaz. También filtra el directorio de tallas y mantiene la propiedad oculta _tn_fit de la línea del carrito
   (ruta y talla elegidas con la herramienta; nunca medidas), para comparar cambios por talla con y sin herramienta. */
(() => {
  'use strict';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const boot = (() => { try { return JSON.parse($('#FitV2Strings')?.textContent || '{}'); } catch { return {}; } })();
  const dialog = $('#FitDialog');
  const content = $('#FitContent');
  const PENDING = 'tn-fit-pending';
  let request = null, scriptsPromise = null, returnToQuick = null;

  function track(name, data) {
    try { window.Shopify?.analytics?.publish?.('tn_fit:' + name, data || {}); } catch { /* sin píxel no pasa nada */ }
  }
  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const s = document.createElement('script'); s.src = src; s.async = true; s.onload = resolve; s.onerror = reject; document.head.append(s);
    });
  }
  function scripts() {
    if (window.AtelierFitCore && window.AtelierFitApp) return Promise.resolve();
    if (!boot.core || !boot.app) return Promise.reject(new Error('fit assets'));
    scriptsPromise ||= loadScript(boot.core).then(() => loadScript(boot.app)).catch(error => { scriptsPromise = null; throw error; });
    return scriptsPromise;
  }

  // Propiedad oculta de la línea del carrito. Se quita si luego se cambia la talla a mano.
  function setProperty(form, variantId, value) {
    if (!form) return;
    let input = form.querySelector('input[name="properties[_tn_fit]"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[_tn_fit]'; form.append(input); }
    input.value = value; input.dataset.variant = String(variantId);
  }
  document.addEventListener('change', event => {
    const form = event.target.closest?.('form[data-product-form]');
    const input = form?.querySelector('input[name="properties[_tn_fit]"]');
    if (!input) return;
    setTimeout(() => { const select = form.querySelector('select[name="id"]'); if (select && select.value !== input.dataset.variant) input.remove(); });
  });
  // Talla elegida desde otra página (directorio): la ficha la recoge al cargar si la variante coincide.
  function pending(variantId, value) {
    try { sessionStorage.setItem(PENDING, JSON.stringify({ variant: String(variantId), value, at: Date.now() })); } catch { /* sin almacenamiento */ }
  }
  (() => {
    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(PENDING) || 'null'); } catch { return; }
    if (!saved) return;
    if (Date.now() - saved.at > 30 * 60 * 1000) { try { sessionStorage.removeItem(PENDING); } catch {} return; }
    const form = $('.product-details form[data-product-form]');
    const select = form && $('select[name="id"]', form);
    if (select && select.value === saved.variant) { setProperty(form, saved.variant, saved.value); try { sessionStorage.removeItem(PENDING); } catch {} }
  })();

  function sourceOf(trigger) {
    if (trigger?.closest('#QuickDialog')) return 'quick';
    if (trigger?.closest('[data-fit-directory]')) return 'directory';
    if (trigger?.closest('#FitDialog')) return 'fit';
    if (trigger?.closest('.product-details, .product-page')) return 'pdp';
    return 'other';
  }
  function message(text, retryUrl) {
    const box = document.createElement('div'); box.className = 'fit-loading';
    const p = document.createElement('p'); p.textContent = text; box.append(p);
    if (retryUrl) {
      const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'button'; retry.textContent = boot.retry || 'Retry';
      retry.addEventListener('click', () => load(retryUrl)); box.append(retry);
      // La tabla sigue en el HTML de la ficha: si falla la carga, se puede ir a ella.
      const destination = new URL(retryUrl, location.origin);
      const local = $('.product-details details[id^="SizeGuide-"]');
      const table = document.createElement('a'); table.className = 'text-link'; table.textContent = boot.table || '';
      if (local && destination.pathname === location.pathname) {
        table.href = '#' + local.id;
        table.addEventListener('click', event => { event.preventDefault(); close(); local.open = true; local.scrollIntoView({ block: 'center' }); $('summary', local)?.focus({ preventScroll: true }); });
      } else table.href = destination.pathname;
      if (boot.table) box.append(table);
    }
    content.replaceChildren(box);
  }
  async function load(productUrl, trigger) {
    request?.abort(); request = new AbortController(); const active = request;
    content.setAttribute('aria-busy', 'true');
    message(boot.loading || '…');
    const timer = setTimeout(() => active.abort(), 18000);
    try {
      const url = new URL(productUrl, location.origin); url.hash = ''; url.searchParams.set('section_id', 'atelier-fit');
      const [html] = await Promise.all([fetch(url, { signal: active.signal }).then(r => { if (!r.ok) throw new Error(r.status); return r.text(); }), scripts()]);
      if (active !== request || !dialog.open) return;
      const app = $('[data-fit-app]', new DOMParser().parseFromString(html, 'text/html'));
      if (!app) throw new Error('fit section');
      content.replaceChildren(app);
      window.AtelierFitApp.mount(app, { form: formFor(trigger), source: sourceOf(trigger), trigger, track, setProperty, pending, close, reopenQuick });
    } catch (error) {
      if (active !== request || !dialog.open) return;
      message(boot.error || 'Error', productUrl);
    } finally {
      clearTimeout(timer); if (active === request) content.removeAttribute('aria-busy');
    }
  }
  function formFor(trigger) {
    const inside = trigger?.closest('form[data-product-form]');
    if (inside) return inside;
    const quick = trigger?.closest('#QuickDialog');
    if (quick) return $('form[data-product-form]', quick);
    return $('.product-details form[data-product-form]');
  }
  function close() { if (!dialog.open) return; if (window.AtelierDialogs?.close) window.AtelierDialogs.close(dialog); else dialog.close(); }
  function reopenQuick() {
    const trigger = returnToQuick; returnToQuick = null;
    if (!trigger?.isConnected) return false;
    window.AtelierDialogs?.open('QuickDialog', trigger);
    return true;
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-fit-url]');
    if (!trigger || !dialog || !content || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!window.AtelierDialogs) return;
    event.preventDefault();
    const source = sourceOf(trigger);
    if (source === 'quick') returnToQuick = trigger;
    else if (source !== 'fit') returnToQuick = null;
    if (!dialog.open && !window.AtelierDialogs.open('FitDialog', trigger)) return;
    track('open', { product_url: new URL(trigger.dataset.fitUrl, location.origin).pathname, source });
    load(trigger.dataset.fitUrl, trigger);
  });
  // Cargar los scripts en cuanto el comprador apunta a la entrada: al hacer clic ya están.
  document.addEventListener('pointerover', event => { if (event.target.closest?.('[data-fit-url]')) scripts().catch(() => {}); }, { passive: true });
  document.addEventListener('focusin', event => { if (event.target.closest?.('[data-fit-url]')) scripts().catch(() => {}); });
  // Cerrar «Encuentra tu talla» abierta desde la vista rápida devuelve a la vista rápida. El cierre se detecta por el
  // atributo open (no depende de fotogramas, a diferencia del evento close).
  let wasOpen = false;
  function onClosed() {
    request?.abort();
    if (!returnToQuick) return;
    // Si se abre otro diálogo (bolsa, o la vista rápida al elegir talla) ya está abierto y no se vuelve atrás.
    queueMicrotask(() => {
      if (!returnToQuick) return;
      if (document.querySelector('dialog[open]')) { returnToQuick = null; return; }
      const trigger = returnToQuick;
      if (reopenQuick()) trigger.focus({ preventScroll: true });
    });
  }
  if (dialog) new MutationObserver(() => { if (wasOpen && !dialog.open) onClosed(); wasOpen = dialog.open; }).observe(dialog, { attributes: true, attributeFilter: ['open'] });

  // Búsqueda en los cinco idiomas: sin tildes, con los tipos de prenda y los colores traducidos (los nombres de color
  // del catálogo están en inglés). La usan el directorio y la lista de prendas de la herramienta.
  const fold = s => String(s || '').toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
  const COLOURS = { black: 'negro negra noir noire schwarz nero nera', white: 'blanco blanca blanc blanche weiss bianco bianca',
    grey: 'gris grau grigio grigia gray', gray: 'gris grau grigio grigia grey', navy: 'marino azul marine blau blu', khaki: 'caqui kaki cachi',
    green: 'verde vert grun', blue: 'azul bleu blau blu', brown: 'marron braun', red: 'rojo roja rouge rot rosso rossa',
    sand: 'arena sable sabbia', cream: 'crema creme', wine: 'vino burdeos bordeaux', orange: 'naranja arancione', beige: 'beis' };
  const TYPES = { tee: 'camiseta camisetas t-shirt tshirt tee maglietta magliette manga corta', tank: 'tirantes tank top tanktop singlet debardeur canotta canottiera sin mangas armellos',
    crop: 'crop cropped top corto court kurz', hoodie: 'sudadera capucha hoodie hoody sweat capuche kapuzenpullover kapuzenpulli felpa cappuccio',
    sweatshirt: 'sudadera sweatshirt crewneck sweat pull pullover pulli felpa girocollo', socks: 'calcetines socks chaussettes socken calzini' };
  function searchable(text, type) {
    let q = fold(text + ' ' + (TYPES[type] || ''));
    for (const [word, more] of Object.entries(COLOURS)) if (q.includes(word)) q += ' ' + more;
    return q;
  }
  const matches = (q, query) => fold(query).split(/\s+/).filter(Boolean).every(w => q.includes(w));
  window.AtelierFitSearch = Object.freeze({ searchable, matches });

  // Directorio: búsqueda y filtro por tipo. Sin JS se ve todo.
  const directory = $('[data-fit-directory]');
  if (directory) {
    const items = $$('.fit-dir-item', directory).map(el => ({ el, type: el.dataset.type, q: searchable(el.dataset.q, el.dataset.type) }));
    const input = $('[data-fit-dir-search]', directory), status = $('[data-fit-dir-status]', directory), empty = $('[data-fit-dir-empty]', directory);
    let type = '';
    const apply = () => {
      let shown = 0;
      for (const item of items) {
        const visible = (!type || item.type === type) && matches(item.q, input.value);
        item.el.hidden = !visible; if (visible) shown++;
      }
      for (const group of $$('[data-fit-dir-group]', directory)) {
        const count = $$('.fit-dir-item:not([hidden])', group).length;
        group.hidden = !count; const badge = $('h2 > span', group); if (badge) badge.textContent = count;
      }
      empty.hidden = shown > 0;
      status.textContent = shown ? (status.dataset.countTemplate || '').replace('{count}', shown) : status.dataset.empty;
    };
    input?.addEventListener('input', apply);
    $$('[data-fit-dir-type]', directory).forEach(button => button.addEventListener('click', () => {
      type = button.dataset.fitDirType;
      $$('[data-fit-dir-type]', directory).forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      apply();
    }));
    const initial = new URLSearchParams(location.search).get('q');
    if (initial && input) { input.value = initial; apply(); }
  }
})();
